import { useTranslation } from 'react-i18next';
import React, {useState, Fragment,useRef} from 'react';
import MasterStamm from "../MasterStammComponent/MasterStamm";
import apiRequest from '../../functions/api';
import { useMessage } from '../../context/message-context';
import InputBox from '../shared/components/InputBox';
import { FullPageSpinner } from "../lib";
function Lagerorte(props) {
  const { t } = useTranslation();
const { accessToken,  client,} = props;
const [stamm,setStamm] = useState([]);
const zeilenauswahl=useRef("");
const spaltenauswahl=useRef("");
const [openibox,setOpenIBox] = useState(false);
const {hideMessage, showErrorMessage,showSuccessMessage} = useMessage();
const [fragen,setFragen] = useState([]);
const [iboxtitle,setIBoxTitle]=useState("");
const [auswahl,setAuswahl]=useState("");
const [ansichtstatus, setAnsichtstatus]=useState("");
const [spin,setSpin]=useState(false);
const errorcB = () => {
  showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
const anfrageCB = (response) => {
   setSpin(false);
   setOpenIBox(false);
   if (response.status === 200) {
      if (response.data.message) {
        if (response.data.message!=="ok") {
          showSuccessMessage(response.data.message);
        }
      }
      if (response.data.stamm) {
        setStamm(response.data.stamm);
      }
      if (response.data.fragen) {
        setFragen(response.data.fragen);
        setOpenIBox(true);
      }
      if (response.data.titel) {
        setIBoxTitle(response.data.titel);
      }
      if (response.data.ansichtstatus) {
        setAnsichtstatus(response.data.ansichtstatus);
      }
   } else {
       if (response) {
         showErrorMessage(response.data.message);
       } else {
         showErrorMessage(t("Keine Internetverbindung"));
       }
   }      
 }
 const buttonAnfrage = (statement,button,key) => {
   const payload={
     "mandant": client,
     "program": "HRLORT",
     "statement": statement,
     "button": button,
     "key":key,
     "ansichtstatus": ansichtstatus,
   }
   const headers={
     "Authorization": "Bearer "+accessToken,
   }
   apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
 }
 
 const inputBoxResult = (results) => {
  const payload={
    "mandant": client, // this.props.client,
    "program": "HRLORT",
    "button": spaltenauswahl.current,
    "key": zeilenauswahl.current,
    "statement": "BUTTON_SPEICHERN",
    "antworten": results,
    "ansichtstatus": ansichtstatus,
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
}
const buttonClick = (spaltenkey,zeilenkey) => {
    switch (spaltenkey) {
       default:
         zeilenauswahl.current=zeilenkey
         spaltenauswahl.current=spaltenkey  
         buttonAnfrage("BUTTON_START",spaltenkey,zeilenkey) 
       break;
   }
}
 return (
    <Fragment>
    <MasterStamm accessToken={accessToken} client={client} pvxprogramm={"HRLORT"} buttonClick={buttonClick} stamm={stamm} setStamm={setStamm} auswahl={auswahl} setAuswahl={setAuswahl} ansichtstatus={ansichtstatus} setAnsichtstatus={setAnsichtstatus} StartFilter={""}  ></MasterStamm>
    
    <InputBox
      open={openibox}
      handleResponse={inputBoxResult}
      fragen={fragen}
      title={iboxtitle}
      onClose={() => setOpenIBox(false)}
     />
    { spin &&
      <FullPageSpinner/>
    }
  </Fragment>
 
    )
}
export default Lagerorte;
